module.exports = __webpack_public_path__ + "img/2.002b0782.png";